import { IntlShape } from 'react-intl';
import { FIELD_NAMES } from 'utils/constants';

function getTitleFromMetadata(
  request: ServiceRequest,
  serviceRequestMetadata: ServiceRequestMetadata,
  intl: IntlShape,
) {
  const requestTypeField = (serviceRequestMetadata?.fields ?? []).find(
    field => field.name === FIELD_NAMES.REQUEST_TYPE,
  );
  if (!requestTypeField) return null;

  const selectedRequestType = requestTypeField.options?.find(
    option => option.name.toString() === request.request_type?.toString(),
  );
  if (!selectedRequestType) return null;

  return intl.formatMessage({
    id: `issueTypes.${selectedRequestType.name}`,
    defaultMessage: selectedRequestType.name ?? request.request_type?.toString(),
  });
}

export const getServiceRequestTitle = (
  request: ServiceRequest,
  serviceRequestMetadata: ServiceRequestMetadata,
  intl: IntlShape,
) => {
  const metadataTitle = getTitleFromMetadata(request, serviceRequestMetadata, intl);
  if (metadataTitle) return metadataTitle;

  if (request.request_type_name) {
    return intl.formatMessage({
      id: `issueTypes.${request.request_type_name}`,
      defaultMessage: request.request_type_name,
    });
  }

  if (request.request_type_description) {
    return request.request_type_description;
  }

  return intl.formatMessage({ id: 'missing_issue_type' });
};
